import {SynthesisService} from "./synthesis.service";
import {EmployeeRoleEnum} from "../../../domain/enum/employee-role.enum";
import {FrCaIcsVtSynthesisService} from "./fr/ca-ics-vt/fr.ca-ics-vt.synthesis.service";
import {TranslationServiceInterface} from "../../translation-service.interface";
import {FrCaIcsHbeSynthesisService} from "./fr/ca-ics-hbe/fr.ca-ics-hbe.synthesis.service";
import {FrAcSynthesisService} from "./fr/ac/fr.ac.synthesis.service";
import {FrDiscoSynthesisService} from "./fr/disco/fr.disco.synthesis.service";

export class SynthesisServiceFactory {

    public static getSynthesisService(role: EmployeeRoleEnum, translationService: TranslationServiceInterface): SynthesisService {
        switch (role) {
            case EmployeeRoleEnum.CA_ICS_HBE:
                return new FrCaIcsHbeSynthesisService(translationService);
            case EmployeeRoleEnum.CA_ICS_VT:
                return new FrCaIcsVtSynthesisService(translationService);
            case EmployeeRoleEnum.AC:
            case EmployeeRoleEnum.CRV_PRO:
                return new FrAcSynthesisService(translationService);
            case EmployeeRoleEnum.CSC:
            case EmployeeRoleEnum.CCL:
            case EmployeeRoleEnum.CC:
            case EmployeeRoleEnum.ASC:
            case EmployeeRoleEnum.CSL:
            case EmployeeRoleEnum.DC:
                return new FrDiscoSynthesisService(translationService);
            default:
                throw new Error(`No synthesis service defined for role: ${role}`);
        }
    }
}
